import styled, { CSSObject } from 'styled-components';

export const defaultCellStyle: CSSObject = {
  textAlign: 'left',
  color: 'inherit',
  padding: '8px 0',
  borderBottom: '1px solid #f0f0f0',
};
export const TableCell = styled.td(defaultCellStyle);
